import useLottie from '@molecules/LottiePlayer/useLottie';
import { LottieOptions } from '@molecules/LottiePlayer/lottieTypes';

/** Do not use this component directly, use LottiePlayer instead to enable dynamic importing */
const LottiePlayerInternal = (props: LottieOptions) => {
  const { View } = useLottie(props);
  return View;
};

export default LottiePlayerInternal;
